@if (items().length) {
  <div cosmosScrollFade [fadeAxis]="'y'" [fadeSizeY]="'0.75rem'" class="relative mb-5">
    <ul class="flex flex-wrap gap-x-3 gap-y-1 max-h-20 overflow-y-auto m-0 py-0 list-none px-3">
      @for (item of items(); track item.datasetIndex) {
        <li
          class="flex items-center gap-1.5 cursor-pointer select-none"
          (click)="toggle.emit(item.datasetIndex)"
        >
          <span
            class="inline-block w-3 h-3 rounded-sm shrink-0 border"
            [class.opacity-40]="item.hidden"
            [style.background]="item.fillStyle"
            [style.border-color]="item.strokeStyle"
          ></span>
          <span
            class="text-sm"
            [class.text-surface-700]="!item.hidden"
            [class.dark:text-surface-300]="!item.hidden"
            [class.text-surface-400]="item.hidden"
            [class.dark:text-surface-500]="item.hidden"
          >{{ item.text }}</span>
        </li>
      }
    </ul>
  </div>
}
